import { Backdrop, CircularProgress, Collapse, Container, CssBaseline } from "@mui/material";
import Questionnaire from "../Questionnaire/Questionnaire";
import MainForm from "../MainForm/MainForm";
import { useAppSelector } from "../../redux/hooks";
import { IState } from "../../models/MainFormState";
import { useCountries } from "../../hooks/useCountries";




    export default function EAPForm(){
        const proceed = useAppSelector((state: IState) => state.questionnaire.isProceed);
        const isLoading = useAppSelector((state:IState) => state.questionnaire.isLoading);
        const { countries, countriesLoading, countriesError } = useCountries();
        if (proceed === null) return null;
        return(
            <Container component="main" maxWidth={proceed ? "lg" : "md"}>
            <Backdrop
              sx={{
                zIndex: 8000,
                color: "#fff",
              }}
              open={isLoading}
            >
              <CircularProgress color="inherit" />
            </Backdrop>

            <CssBaseline />

              <Collapse in={!proceed}>
                <Questionnaire countries={countries} countriesLoading={countriesLoading} countriesError={countriesError} />
              </Collapse>

              <Collapse in={proceed}>
                <MainForm countries={countries} countriesLoading={countriesLoading} countriesError={countriesError} />
              </Collapse>
         </Container>

        )
    }